(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSUnidadReceptoraController', SSUnidadReceptoraController);

    SSUnidadReceptoraController.$inject = ['SSUnidadReceptora'];

    function SSUnidadReceptoraController(SSUnidadReceptora) {

        var vm = this;

        vm.sSUnidadReceptoras = [];

        loadAll();

        function loadAll() {
            SSUnidadReceptora.query(function(result) {
                vm.sSUnidadReceptoras = result;
                vm.searchQuery = null;
            });
        }
    }
})();
